import React from 'react';
import Slider from 'react-slick';
import '../../../../styles/FlightRoute.css';
import PropTypes from 'prop-types';

const FlightRoute = ({ data }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4.3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2.8,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <Slider {...settings}>
      {data &&
        data.length > 0 &&
        data.map(
          ({
            id,
            flightName,
            flightIcon,
            newPrice,
            from,
            to,
            departureTime,
            depMeridies,
            arrivalTime,
            arrMeridies,
            cta,
            url
          }) => (
            <div key={id} className="rlFlightItem">
              <div className="rlFlightItem__desc">
                <div className="makeFlex hrtlCenter appendBottom10">
                  <span className="rlFlightItem__icon">
                    <div className={flightIcon} />
                  </span>
                  <span className="font10">{flightName}</span>
                </div>
                <div className="makeFlex hrtlCenter appendBottom3">
                  {from && <span className="latoBold font11 rlFlightItem__from">{from}</span>}
                  {to && (
                    <span style={{ marginLeft: 'auto' }} className="latoBold font11">
                      {to}
                    </span>
                  )}
                </div>
                <div className="makeFlex hrtlCenter">
                  <span className="font12">{departureTime}</span>
                  <span className="font8 greyText appendLeft3">{depMeridies}</span>
                  <span className="distanceBar"></span>
                  <span className="font12">{arrivalTime}</span>
                  <span className="font8 greyText appendLeft3">{arrMeridies}</span>
                </div>
                <div className="rlFlightItem__foot">
                  <div>
                    {/* {oldPrice && <p className="font10 greyText"><span className="lineThrough">₹{oldPrice}</span></p>} */}
                    {newPrice && (
                      <p>
                        <span className="font16 blackText">₹{newPrice}</span>
                      </p>
                    )}
                  </div>
                  {cta && (
                    <p className="rlFlightItem__cta">
                      <a href={url} className="capText latoBlack font12">
                        {cta}
                      </a>
                    </p>
                  )}
                </div>
              </div>
            </div>
          )
        )}
    </Slider>
  );
};

FlightRoute.propTypes = {
  data: PropTypes.array
};

export default FlightRoute;
